import { BillOfLadingRouteService } from 'common/data';
import { BaseService } from 'core/services';

class BillOfLadingService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new BillOfLadingRouteService());
	}
	print(id) {
		var url = this.routeService.print(id);
		return this.apiClient.get(url);
	}

	pull(id) {
		var url = this.routeService.pull(id);
		return this.apiClient.get(url);
	}

	acquire(id, source) {
		var url = this.routeService.acquire(id, source);
		return this.apiClient.get(url);
	}

	upload = async (id, data) => {
		const url = this.routeService.upload(id);
		return this.apiClient.post(url, data);
	};

	void = async (id, data) => {
		const url = this.routeService.void(id);
		return this.apiClient.put(url, data);
	};

	pullBulk(ids) {
		const url = this.routeService.pullBulk(ids);
		return this.apiClient.put(url, ids);
	}
}

export default BillOfLadingService;
